import { createSelector } from 'reselect';

const reports = state => {
    if (!state) return null;
    if (typeof state.get === 'function') {
        return state.get('reports');
    }
    return state.reports || null;
};

const selectReportApiCount = () => createSelector(reports, state => (state ? state.toJS().count : 0));
const selectReportError = () => createSelector(reports, state => (state ? state.toJS().error : ''));
const selectRespondent = () => createSelector(reports, state => (state ? state.toJS().respondent : 0));
const selectPreviousRespondent = () => createSelector(reports, state => (state ? state.toJS().previousRespondent : 0));
const selectComments = () => createSelector(reports, state => (state ? state.toJS().comments : {}));
const selectReportApiParams = () => createSelector(reports, state => (state ? state.toJS().reportApiParams : {}));
const selectBuFilters = () => createSelector(reports, state => (state ? state.toJS().buDemographics : []));
const selectPracticeFilters = () => createSelector(reports, state => (state ? state.toJS().practiceDemographics : []));
const selectBenchDataFetched = () => createSelector(reports, state => (state ? state.toJS().benchDataFetched : false));
const selectDemograhicDataFetched = () =>
    createSelector(reports, state => (state ? state.toJS().demograhicDataFetched : false));
const selectExBenchDataFetched = () =>
    createSelector(reports, state => (state ? state.toJS().exBenchDataFetched : false));
const selectFilterIndex = () => createSelector(reports, state => (state ? state.toJS().filterIndex : 0));
const selectPastReports = () => createSelector(reports, state => (state ? state.toJS().pastReport : []));
const selectCurrentTab = () => createSelector(reports, state => (state ? state.toJS().currentTab : 0));
const selectInclusionData = () => createSelector(reports, state => (state ? state.toJS().inclusionData : {}));
const selectGapData = () => createSelector(reports, state => (state ? state.toJS().gapData : {}));
const selectGapDataFetched = () => createSelector(reports, state => (state ? state.toJS().gapDataFetched : false));
const selectGraphData = () => createSelector(reports, state => (state ? state.toJS().graphData : {}));
const selectGraphDataFetched = () => createSelector(reports, state => (state ? state.toJS().graphDataFetched : false));
const selectPendingReports = () => createSelector(reports, state => (state ? state.toJS().pendingReports : []));
const selectBulkDemographics = () => createSelector(reports, state => (state ? state.toJS().bulkDemographics : []));
const selectShowBulk = () => createSelector(reports, state => (state ? state.toJS().showBulk : false));
const selectMappedDemos = () => createSelector(reports, state => (state ? state.toJS().mappedDemos : []));
const selectResurveyDemographics = () =>
    createSelector(reports, state => (state ? state.toJS().resurveyDemographics : []));
const selectResurveyDemographicDataFetched = () =>
    createSelector(reports, state => (state ? state.toJS().resurveyDemographicDataFetched : false));
const selectShowAvgGap = () => createSelector(reports, state => (state ? state.toJS().showAvgGap : false));
const selectTaskId = () => createSelector(reports, state => (state ? state.toJS().taskId : ''));
const selectShowMultiProgress = () =>
    createSelector(reports, state => (state ? state.toJS().showMultiProgress : false));
const selectPreviousCompRespondent = () =>
    createSelector(reports, state => (state ? state.toJS().previousCompRespondent : 0));
const selectScoreBulkData = () => createSelector(reports, state => (state ? state.toJS().scoreBulkData : {}));
const selectScoreBulkDataFetched = () =>
    createSelector(reports, state => (state ? state.toJS().scoreBulkDataFetched : false));
const selectOrgLevelBu = () => createSelector(reports, state => (state ? state.toJS().orgLevelBu : []));
const selectBuScorecardEntireOrganization = () =>
    createSelector(reports, state => (state ? state.toJS().buScorecardEntireOrganization : true));
const selectPracticeRankingEntireOrganization = () =>
    createSelector(reports, state => (state ? state.toJS().practiceRankingEntireOrganization : true));
const selectEntireOrganizationComparison = () => selectBuScorecardEntireOrganization();

export {
    selectReportError,
    selectReportApiCount,
    selectReportApiParams,
    selectBuFilters,
    selectBenchDataFetched,
    selectDemograhicDataFetched,
    selectFilterIndex,
    selectPastReports,
    selectCurrentTab,
    selectInclusionData,
    selectGapData,
    selectGapDataFetched,
    selectPendingReports,
    selectRespondent,
    selectPreviousRespondent,
    selectGraphData,
    selectGraphDataFetched,
    selectComments,
    selectPracticeFilters,
    selectBulkDemographics,
    selectShowBulk,
    selectMappedDemos,
    selectResurveyDemographics,
    selectResurveyDemographicDataFetched,
    selectShowAvgGap,
    selectTaskId,
    selectShowMultiProgress,
    selectPreviousCompRespondent,
    selectScoreBulkData,
    selectScoreBulkDataFetched,
    selectOrgLevelBu,
    selectBuScorecardEntireOrganization,
    selectPracticeRankingEntireOrganization,
    selectEntireOrganizationComparison,
    selectExBenchDataFetched,
};
